import { SensorGroupSensorStateType } from './state'

export interface SensorGroupSensorGettersType {
  getSensorGroupSensorById: (state: SensorGroupSensorStateType, id: string) => SensorGroupSensorStateType['sensorGroupSensor']
  getSensorGroupSensorsByGroupId: (state: SensorGroupSensorStateType, groupId: string) => SensorGroupSensorStateType['sensorGroupSensors']
  getSensorGroupSensorsBySensorId: (state: SensorGroupSensorStateType, sensorId: string) => SensorGroupSensorStateType['sensorGroupSensors']
  getSensorGroupSensorByGroupAndSensor: (state: SensorGroupSensorStateType, groupId: string, sensorId: string) => SensorGroupSensorStateType['sensorGroupSensor']
  getSortedSensorsByGroupId: (state: SensorGroupSensorStateType, groupId: string) => SensorGroupSensorStateType['sensorGroupSensors']
}

export const SensorGroupSensorGetters = {
  getSensorGroupSensorById: (state: SensorGroupSensorStateType) => (id: string) => {
    return state.sensorGroupSensors.find(sensorGroupSensor => sensorGroupSensor.id === id)
  },
  getSensorGroupSensorsByGroupId: (state: SensorGroupSensorStateType) => (groupId: string) => {
    return state.sensorGroupSensors.filter(sensorGroupSensor => sensorGroupSensor.groupId === groupId)
  },
  getSensorGroupSensorsBySensorId: (state: SensorGroupSensorStateType) => (sensorId: string) => {
    return state.sensorGroupSensors.filter(sensorGroupSensor => sensorGroupSensor.sensorId === sensorId)
  },
  getSensorGroupSensorByGroupAndSensor: (state: SensorGroupSensorStateType) => (groupId: string, sensorId: string) => {
    return state.sensorGroupSensors.find(sensorGroupSensor => 
      sensorGroupSensor.groupId === groupId && sensorGroupSensor.sensorId === sensorId
    )
  },
  getSortedSensorsByGroupId: (state: SensorGroupSensorStateType) => (groupId: string) => {
    return state.sensorGroupSensors
      .filter(sensorGroupSensor => sensorGroupSensor.groupId === groupId)
      .sort((a, b) => a.position - b.position)
  },
}
